<template>
  <div class="container">
    <div class="content">
      <h4 class="title is-4">Here's a brief summary of your situation:</h4>
      <p v-if="message == 1">
        Good news, it looks like both your monthly and future net are positive.
        That implies that over time your net worth and savings will increase.
        Assuming you like money, this is a good situation to be in.
      </p>
      <p v-if="message == 2">
        Your situation is a little mixed. It looks like your currently monthly
        net is negative, but your future net is positive. Ultimately, you'll
        need to decide if you feel comfortable riding out the dip until it turns
        positive.
      </p>
      <p v-if="message == 3">
        Your situation is a little mixed. It looks like your currently monthly
        net is positive, but your future monthly net is negative. You're
        expected to run out of savings sometime around month
        {{ parseInt(goes_zero) }}.
      </p>
      <p v-if="message == 4">
        It looks both your current and future monthly net are negative. Given
        the amount you have it savings, it looks like you might run out of
        savings around month {{ parseInt(goes_zero) }}.
      </p>
      <p v-if="message == 5">
        Your situation is a little mixed. It looks like your currently monthly
        net is positive, but your future monthly net is negative. On the upside
        it doesn't look like your savings will run out in the next 100 months.
      </p>
      <p v-if="message == 6">
        It looks both your current and future monthly net are negative. The good
        news is that it doesn't look like you'll run out of savings in the next
        100 months.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Summary",
  props: {
    monthly_net_current: Number,
    monthly_net_future: Number,
    goes_zero: Number,
  },
  data() {
    return {};
  },
  computed: {
    message: function () {
      if (this.monthly_net_current >= 0 && this.monthly_net_future >= 0) {
        return 1;
      } else if (this.monthly_net_current < 0 && this.monthly_net_future >= 0) {
        return 2;
      } else if (this.monthly_net_current >= 0 && this.monthly_net_future < 0) {
        if (this.goes_zero === 100) {
          return 5;
        } else {
          return 3;
        }
      } else if (this.monthly_net_current < 0 && this.monthly_net_future < 0) {
        if (this.goes_zero === 100) {
          return 6;
        } else {
          return 4;
        }
      } else {
        return "";
      }
    },
  },
};
</script>